import { render, staticRenderFns } from "./RecognitionByHeaderField.vue?vue&type=template&id=f5b0527e&"
import script from "./RecognitionByHeaderField.vue?vue&type=script&lang=ts&"
export * from "./RecognitionByHeaderField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports